package network

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.database.database


object FirebaseClient {
    val database get() = Firebase.database
    val auth get() = Firebase.auth
}